<template>
  <div class="container mt-5" style="padding-bottom: 10rem">
    <md-card class="p-3">
      <md-card-header class="text-center">
        <div class="md-title">Datos</div>
        <div class="md-subhead">Ingresa los datos solicitados</div>
      </md-card-header>
      <md-tabs :md-active-tab="0">
        <md-tab id="1" md-label="Registro">
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <md-field>
                <label class="md-required">Fecha</label>
                <md-input type="date" v-model="dateRegistro"></md-input>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label class="md-required">Fecha 1er. gasto</label>
                <md-input type="date" v-model="fechaPrimerGasto"></md-input>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label class="md-required">Fecha 1er. reclamación</label>
                <md-input
                  type="date"
                  v-model="fechaPrimerReclamacion"
                ></md-input>
              </md-field>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <md-field>
                <label class="md-required">Hora</label>
                <md-input type="time" v-model="horaRegistro"></md-input>
              </md-field>
            </div>
            <div class="col-md-6">
              <md-field>
                <label>Descripción</label>
                <md-textarea v-model="descripcionRegistro"></md-textarea>
              </md-field>
            </div>
          </div>
        </md-tab>
        <md-tab id="2" md-label="Escuela">
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <md-field>
                <md-select
                  name="Seguro"
                  id="seguro"
                  placeholder="Tipo de seguro"
                  v-model="seguro"
                >
                  <md-option value="particular"> Particular </md-option>
                  <md-option value="publica"> Pública </md-option>
                  <md-option value="empleado/dependientes">
                    Empleado/dependientes
                  </md-option>
                </md-select>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field :class="errorClave">
                <label>Clave</label>
                <md-input
                  v-model="clave"
                  @change="escuelaSearch($event)"
                  :disabled="selectedEscuela.Clave"
                ></md-input>
                <span v-if="errors" class="md-error">Clave invalida.</span>
                <div>
                  <md-dialog :md-active.sync="showDialogEscuelas">
                    <md-dialog-title>Escuelas</md-dialog-title>
                    <md-dialog-content v-if="showDialogEscuelas">
                      <md-tabs md-dynamic-height>
                        <md-tab md-label="General">
                          <!-- Buscador -->
                          <!-- Campo de búsqueda -->
                          <md-field>
                            <label>Buscar escuela</label>
                            <md-input
                              v-model="busquedaEscuela"
                              @input="filtrarEscuelas"
                              placeholder="Por clave"
                            ></md-input>
                            <md-input
                              v-model="busquedaMunicipio"
                              @input="filtrarEscuelas"
                              placeholder="Por municipio"
                            ></md-input>
                            <md-input
                              v-model="busquedaNombre"
                              @input="filtrarEscuelas"
                              placeholder="Por nombre"
                            ></md-input>
                          </md-field>

                          <!-- Tabla -->
                          <div>
                            <md-table
                              v-model="paginatedData"
                              md-card
                              md-fixed-header
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                                :class="getClassEscuela(item)"
                                md-selectable="single"
                                @click="onSelectEscuela(item)"
                              >
                                <md-table-cell
                                  md-label="Clave"
                                  md-sort-by="Clave"
                                  md-numeric
                                  >{{ item.Clave }}</md-table-cell
                                >
                                <md-table-cell
                                  md-label="Nivel"
                                  md-sort-by="NombreComercial"
                                  >{{ item.Nivel }}</md-table-cell
                                >
                                <md-table-cell
                                  md-label="Municipio"
                                  md-sort-by="RazonSocial"
                                  >{{ item.Municipio }}</md-table-cell
                                >
                                <md-table-cell
                                  md-label="Nombre"
                                  md-sort-by="RazonSocial"
                                  >{{ item.Nombre }}</md-table-cell
                                >
                              </md-table-row>
                            </md-table>

                            <!-- Paginador -->
                              <nav class="pagination-nav">
      <ul class="pagination">
        <li :class="{ disabled: currentPage === 1 }" @click="changePage('prev')">
          <a href="javascript:void(0)">«</a>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          :class="{ active: page === currentPage }"
          @click="changePage(page)"
        >
          <a href="javascript:void(0)">{{ page }}</a>
        </li>
        <li :class="{ disabled: currentPage === totalPages }" @click="changePage('next')">
          <a href="javascript:void(0)">»</a>
        </li>
      </ul>
    </nav>
                          </div>
                        </md-tab>
                      </md-tabs>
                      <md-dialog-actions>
                        <md-button
                          class="md-primary"
                          @click="showDialogEscuelas = false"
                          >Seleccionar</md-button
                        >
                      </md-dialog-actions>
                    </md-dialog-content>
                  </md-dialog>
                  <md-button
                    style="height: 35px !important; width: 10px !important"
                    class="md-icon-button"
                    @click="openDialogEscuelas"
                  >
                    <md-icon><i class="fas fa-search fa-xs"></i></md-icon>
                  </md-button>
                </div>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label>Nombre</label>
                <md-input
                  v-model="nombreEscuela"
                  :disabled="selectedEscuela.Clave"
                ></md-input>
              </md-field>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <md-field>
                <label>Nivel</label>
                <md-input
                  v-model="nivel"
                  :disabled="selectedEscuela.Clave"
                ></md-input>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label>Municipio</label>
                <md-input
                  v-model="municipio"
                  :disabled="selectedEscuela.Clave"
                ></md-input>
              </md-field>
            </div>
          </div>
        </md-tab>
        <md-tab id="3" md-label="Estadisticos">
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <div class="md-layout-item">
                <md-field>
                  <md-select
                    name="Ubicación"
                    id="Ubicación"
                    placeholder="Ubicación"
                    v-model="ubicacion"
                  >
                    <md-option
                      v-for="option in catalogoUbicacion"
                      :key="option.Descripcion"
                      :value="option.Descripcion"
                    >
                      {{ option.Descripcion }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="md-layout-item">
                <md-field>
                  <md-select
                    name="Espacio"
                    id="Espacio"
                    placeholder="Espacio"
                    v-model="espacio"
                  >
                    <md-option
                      v-for="option in catalogoEspacio"
                      :key="option.Descripcion"
                      :value="option.Descripcion"
                    >
                      {{ option.Descripcion }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="md-layout-item">
                <md-field>
                  <md-select
                    name="Accidente"
                    id="Accidente"
                    placeholder="Accidente"
                    v-model="accidente"
                  >
                    <md-option
                      v-for="option in catalogoAccidente"
                      :key="option.Descripcion"
                      :value="option.Descripcion"
                    >
                      {{ option.Descripcion }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <div class="md-layout-item">
                <md-field>
                  <md-select
                    name="Lesión"
                    id="Lesion"
                    placeholder="Lesión"
                    v-model="lesion"
                  >
                    <md-option
                      v-for="option in catalogoLesion"
                      :key="option.Descripcion"
                      :value="option.Descripcion"
                    >
                      {{ option.Descripcion }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
            <div class="col-md-4">
              <div class="md-layout-item">
                <md-field>
                  <md-select
                    name="Cuerpo"
                    id="Cuerpo"
                    placeholder="Cuerpo"
                    v-model="cuerpo"
                  >
                    <md-option
                      v-for="option in catalogoCuerpo"
                      :key="option.Descripcion"
                      :value="option.Descripcion"
                    >
                      {{ option.Descripcion }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
            </div>
          </div>
        </md-tab>
        <md-tab id="4" md-label="acompañante">
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <md-field>
                <label>Nombre(s)</label>
                <md-input v-model="nombre"></md-input>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label>Apellido Paterno</label>
                <md-input v-model="apellidoPaterno"></md-input>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label>Apellido Materno</label>
                <md-input v-model="apellidoMaterno"></md-input>
              </md-field>
            </div>
          </div>
          <div class="row d-flex justify-content-center">
            <div class="col-md-4">
              <md-field>
                <label>Parentesco</label>
                <md-input v-model="parentesco"></md-input>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label>Télefono</label>
                <md-input
                  type="text"
                  v-model="telefono"
                  :maxlength="10"
                  @input="validateTelefono($event)"
                ></md-input>
              </md-field>
            </div>
            <div class="col-md-4">
              <md-field>
                <label>Correo</label>
                <md-input type="email" v-model="correo"></md-input>
              </md-field>
            </div>
          </div>
        </md-tab>
        <md-tab id="5" md-label="Alta medica">
          <div class="row d-flex justify-content-center text-center">
            <div class="col-md-4">
              <div class="row" v-if="selectedHospital">
                <p>Clínica seleccionada: {{ selectedHospital.NOMBRE }}</p>
              </div>
              <div class="row">
                <div>
            <md-dialog :md-active.sync="showDialog">
  <md-dialog-title>Hospitales</md-dialog-title>
  <md-dialog-content>
    <md-tabs md-dynamic-height>
      <md-tab md-label="General">
        <!-- Buscador -->
        <div class="p-3">
          <md-field>
            <label>Buscar hospital</label>
            <md-input
              v-model="busquedaHospital"
              @input="filtrarHospitales"
              placeholder="Escribe clave o nombre del hospital"
            ></md-input>
          </md-field>
        </div>

        <!-- Tabla -->
        <div>
          <md-table
            v-model="paginatedDataHospital"
            md-card
            @md-selected="onSelectHospital"
            md-fixed-header
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              :class="getClassHospital(item)"
              md-selectable="single"
            >
              <md-table-cell md-label="Clave" md-sort-by="Clave" md-numeric>
                {{ item.CVE_PREST_ISEP }}
              </md-table-cell>
              <md-table-cell md-label="Nombre Comercial" md-sort-by="NombreComercial">
                {{ item.NOMBRE }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>

        <!-- Paginador -->
        <nav class="pagination-nav">
          <ul class="pagination">
            <li
              :class="{ disabled: currentPageHospital === 1 }"
              @click="changePageHospital('prev')"
            >
              <a href="javascript:void(0)">«</a>
            </li>
            <li
              v-for="page in totalPagesHospital"
              :key="page"
              :class="{ active: page === currentPageHospital }"
              @click="changePageHospital(page)"
            >
              <a href="javascript:void(0)">{{ page }}</a>
            </li>
            <li
              :class="{ disabled: currentPageHospital === totalPagesHospital }"
              @click="changePageHospital('next')"
            >
              <a href="javascript:void(0)">»</a>
            </li>
          </ul>
        </nav>
      </md-tab>
    </md-tabs>
    <md-dialog-actions>
      <md-button class="md-primary" @click="showDialog = false">
        Seleccionar
      </md-button>
    </md-dialog-actions>
  </md-dialog-content>
</md-dialog>




                  <md-button
                    class="md-primary md-raised"
                    @click="showDialog = true"
                    >Buscar clínica</md-button
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <p>ICD seleccionado: {{ selectedICD.DESC_ENFERMEDAD }}</p>
              </div>
              <div class="row">
                <div>
                  <md-dialog :md-active.sync="showDialogICD">
                    <div class="row pr-5 pl-5 pt-5 text-center">
                      <div class="col-5">
                        <md-field>
                          <label>ICD Clave</label>
                          <md-input v-model="icdClave"></md-input>
                        </md-field>
                      </div>
                      <div class="col-5">
                        <md-field>
                          <label>ICD Descripción</label>
                          <md-input v-model="icdDesc"></md-input>
                        </md-field>
                      </div>
                      <div class="col">
                        <md-button
                          class="md-primary"
                          style="background: #f26e50; color: white"
                          @click="ICD"
                        >
                          <i class="fas fa-search mr-2"></i>
                          Buscar
                        </md-button>
                      </div>
                    </div>
                    <md-dialog-content>
                      <md-tabs md-dynamic-height>
                        <md-tab md-label="ICD">
                          <div>
                            <md-table
                              v-model="catalogoICD"
                              md-card
                              @md-selected="onSelectICD"
                              md-fixed-header
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                                :class="getClassICD(item)"
                                md-selectable="single"
                              >
                                <md-table-cell
                                  md-label="Clave"
                                  md-sort-by="Clave"
                                  md-numeric
                                  >{{ item.CVEL_ICD }}</md-table-cell
                                >
                                <md-table-cell
                                  md-label="Descripcion"
                                  md-sort-by="NombreComercial"
                                  >{{ item.DESC_ENFERMEDAD }}</md-table-cell
                                >
                              </md-table-row>
                            </md-table>
                          </div>
                        </md-tab>
                      </md-tabs>
                      <md-dialog-actions>
                        <md-button
                          class="md-primary"
                          @click="showDialogICD = false"
                          >Seleccionar</md-button
                        >
                      </md-dialog-actions>
                    </md-dialog-content>
                  </md-dialog>

                  <md-button
                    class="md-primary md-raised"
                    @click="showDialogICD = true"
                    >Buscar ICD</md-button
                  >
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="row">
                <p>CTP seleccionadao: {{ selectedCTP.DESC_CPT }}</p>
              </div>
              <div class="row">
                <div>
                  <md-dialog :md-active.sync="showDialogCTP">
                    <div class="row pr-5 pl-5 pt-5 text-center">
                      <div class="col-5">
                        <md-field>
                          <label>CTP Clave</label>
                          <md-input v-model="ctpClave"></md-input>
                        </md-field>
                      </div>
                      <div class="col-5">
                        <md-field>
                          <label>CTP Descripción</label>
                          <md-input v-model="ctpDesc"></md-input>
                        </md-field>
                      </div>
                      <div class="col">
                        <md-button
                          class="md-primary"
                          style="background: #f26e50; color: white"
                          @click="CTP"
                        >
                          <i class="fas fa-search mr-2"></i>
                          Buscar
                        </md-button>
                      </div>
                    </div>
                    <md-dialog-content>
                      <md-tabs md-dynamic-height>
                        <md-tab md-label="CTP">
                          <div>
                            <md-table
                              v-model="catalogoCTP"
                              md-card
                              @md-selected="onSelectCTP"
                              md-fixed-header
                            >
                              <md-table-row
                                slot="md-table-row"
                                slot-scope="{ item }"
                                :class="getClassCTP(item)"
                                md-selectable="single"
                              >
                                <md-table-cell
                                  md-label="Clave"
                                  md-sort-by="Clave"
                                  md-numeric
                                  >{{ item.CVEL_CPT }}</md-table-cell
                                >
                                <md-table-cell
                                  md-label="Descripcion"
                                  md-sort-by="NombreComercial"
                                  >{{ item.DESC_CPT }}</md-table-cell
                                >
                              </md-table-row>
                            </md-table>
                          </div>
                        </md-tab>
                      </md-tabs>
                      <md-dialog-actions>
                        <md-button
                          class="md-primary"
                          @click="showDialogCTP = false"
                          >Seleccionar</md-button
                        >
                      </md-dialog-actions>
                    </md-dialog-content>
                  </md-dialog>

                  <md-button
                    class="md-primary md-raised"
                    @click="showDialogCTP = true"
                    >Buscar CTP</md-button
                  >
                </div>
              </div>
            </div>
            <div class="row pl-5 pr-5 mt-3">
              <md-field>
                <label>Observaciones</label>
                <md-textarea v-model="observaciones"></md-textarea>
              </md-field>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>Autorizado</label>
                <div class="row text-center">
                  <div class="col-2"></div>
                  <div class="col-4">
                    <md-switch
                      v-model="autorizado"
                      value="Si"
                      class="md-primary"
                      >Si</md-switch
                    >
                  </div>
                  <div class="col-4">
                    <md-switch
                      v-model="autorizado"
                      value="No"
                      class="md-primary"
                      >No</md-switch
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <md-field>
                  <label class="md-required">Fecha de consulta</label>
                  <md-input v-model="dateConsulta" type="date"></md-input>
                </md-field>
              </div>
            </div>
          </div>
          <md-button
            style="background: #9cc4e4; color: #586875"
            class="md-primary float-right col-3"
            @click="sendDatos"
          >
            <i class="fas fa-check mr-2"></i>
            {{ textoBoton }}
          </md-button>
        </md-tab>
      </md-tabs>
    </md-card>
    <Loading :isLoading="isLoadingTabs" />
    <AlertModal :showDialog="showAlert" :mensaje="mensajeAlert" />
  </div>
</template>
  
  <script>
import Loading from "./Tools/loading.vue";
import AlertModal from "./Modals/alertModal.vue";

export default {
  name: "TabsOrdering",
  components: {
    Loading,
    AlertModal,
  },
  props: {
    catalogoLesion: Array,
    catalogoEspacio: Array,
    catalogoCuerpo: Array,
    catalogoAccidente: Array,
    catalogoUbicacion: Array,
    catalogoHospitales: Array,
    catalogoEscuelas: Array,
    catalogoICD: Array,
    catalogoCTP: Array,
    textoBoton: String,
  },
  data: () => ({
    showAlert: false,
    mensajeAlert: "",

    icdClave: null,
    icdDesc: null,
    ctpClave: null,
    ctpDesc: null,

    showMiddleTab: false,
    showLastTab: false,
    dynamicId: 100,
    showDialog: false,
    showDialogEscuelas: false,
    showDialogICD: false,
    showDialogCTP: false,
    errors: false,
    isLoadingTabs: false,
    //Datos tabs
    selectedHospital: {},
    selectedEscuela: {},
    selectedICD: {},
    selectedCTP: {},
    autorizado: "",
    dateRegistro: "",
    horaRegistro: "",
    descripcionRegistro: "",
    ubicacion: "",
    espacio: "",
    accidente: "",
    lesion: "",
    cuerpo: "",
    nombre: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    parentesco: "",
    telefono: "",
    correo: "",
    dateConsulta: "",
    observaciones: "",
    clave: "",
    nombreEscuela: "",
    nivel: "",
    municipio: "",
    seguro: "",
    fechaPrimerReclamacion: "",
    fechaPrimerGasto: "",
    busquedaEscuela: "",
    busquedaNombre: "",
    busquedaMunicipio: "",
    catalogoFiltradoEscuelas: [],
    itemsPerPage: 250,
    currentPage: 1,

    busquedaHospital: '',
  catalogoFiltradoHospitales: [], // Lista filtrada de hospitales
  currentPageHospital: 1, // Página actual para los hospitales
  itemsPerPageHospital: 5, // Elementos por página para los hospitales
  }),
  watch: {
    handler: function (val, _) {
      console.log(val);

      this.telefono = val.replace(/\D/g, "");
    },
    showDialogEscuelas(newVal) {
      if (newVal) {
        this.catalogoFiltradoEscuelas = [...this.catalogoEscuelas];
      }
    },
     showDialog(newVal) {
    if (newVal) {
      this.catalogoFiltradoHospitales = [...this.catalogoHospitales];
      this.currentPageHospital = 1; // Reinicia la paginación
    }
  },
  },
  methods: {
    filtrarEscuelas() {
      var filtro = this.busquedaEscuela.toLowerCase();
      var filtroMunicipio = this.busquedaMunicipio.toLowerCase();
      var filtroNombre = this.busquedaNombre.toLowerCase();

      /*console.log(filtro);
      console.log(filtroMunicipio);
      console.log(filtroNombre);*/
      

      this.catalogoFiltradoEscuelas = this.catalogoEscuelas.filter(
        (escuela) => {
          return (
            escuela.Clave.toString().toLowerCase().includes(filtro) 
            /*&& escuela.Nombre.toLowerCase().includes(filtroMunicipio)
            && escuela.Municipio.toLowerCase().includes(filtroNombre)*/
          );
        }
      );

      //const filtroMunicipip = this.busquedaMunicipio.toLowerCase();
      this.catalogoFiltradoEscuelas = this.catalogoFiltradoEscuelas.filter(
        (escuela) => {
          return (
            //escuela.Clave.toString().toLowerCase().includes(filtro) ||
            //escuela.Nombre.toLowerCase().includes(filtro) ||
            escuela.Municipio.toLowerCase().includes(filtroMunicipio)
          );
        }
      );

      //const filtroNombre = this.busquedaNombre.toLowerCase();
      this.catalogoFiltradoEscuelas = this.catalogoFiltradoEscuelas.filter(
        (escuela) => {
          return (
            //escuela.Clave.toString().toLowerCase().includes(filtro) ||
            escuela.Nombre.toLowerCase().includes(filtroNombre) 
            //escuela.Municipio.toLowerCase().includes(filtro)
          );
        }
      );

      /*if (this.busquedaEscuela == '' && this.busquedaNombre == '' && this.busquedaMunicipio == ''){
        this.catalogoFiltradoEscuelas = this.catalogoEscuelas;
      }*/

      this.currentPage = 1; // Reinicia la paginación al filtrar
    },
    filtrarMunicipio(){
      const filtroMunicipip = this.busquedaMunicipio.toLowerCase();
      this.catalogoFiltradoEscuelas = this.catalogoEscuelas.filter(
        (escuela) => {
          return (
            //escuela.Clave.toString().toLowerCase().includes(filtro) ||
            //escuela.Nombre.toLowerCase().includes(filtro) ||
            escuela.Municipio.toLowerCase().includes(filtroMunicipip)
          );
        }
      );
      this.currentPage = 1;
    },
    filtrarNombre(){
      const filtroNombre = this.busquedaNombre.toLowerCase();
      this.catalogoFiltradoEscuelas = this.catalogoEscuelas.filter(
        (escuela) => {
          return (
            //escuela.Clave.toString().toLowerCase().includes(filtro) ||
            escuela.Nombre.toLowerCase().includes(filtroNombre) 
            //escuela.Municipio.toLowerCase().includes(filtro)
          );
        }
      );
      this.currentPage = 1;
    },
    changePage(value) {
      if (value === 'prev' && this.currentPage > 1) {
        this.currentPage--;
      } else if (value === 'next' && this.currentPage < this.totalPages) {
        this.currentPage++;
      } else if (typeof value === 'number') {
        this.currentPage = value;
      }
    },
    openDialogEscuelas() {
      this.showDialogEscuelas = true;
      this.errors = false;
      // this.errorClave = false;
    },

     filtrarHospitales() {
    const filtro = this.busquedaHospital.toLowerCase();
    this.catalogoFiltradoHospitales = this.catalogoHospitales.filter((hospital) => {
      return (
        hospital.CVE_PREST_ISEP.toString().toLowerCase().includes(filtro) ||
        hospital.NOMBRE.toLowerCase().includes(filtro)
      );
    });
    this.currentPageHospital = 1; // Reinicia la paginación al filtrar
  },
  changePageHospital(value) {
    if (value === 'prev' && this.currentPageHospital > 1) {
      this.currentPageHospital--;
    } else if (value === 'next' && this.currentPageHospital < this.totalPagesHospital) {
      this.currentPageHospital++;
    } else if (typeof value === 'number') {
      this.currentPageHospital = value;
    }
  },
    validateTelefono(event) {
      if (/\D/.test(event)) {
        console.log("entra leta");
        this.telefono = this.telefono.slice(0, -1);
      }
    },
    getClassHospital: ({ id }) => ({
      "md-primary": id != 0,
    }),
    getClassEscuela: ({ id }) => ({
      "md-primary": id != 0,
    }),
    getClassCTP: ({ id }) => ({
      "md-primary": id != 0,
    }),
    getClassICD: ({ id }) => ({
      "md-primary": id != 0,
    }),
    onSelectHospital(item) {
      this.selectedHospital = item;
      console.log("seleccionado", this.selectedHospital.NOMBRE);
      if (item != {}) {
        setTimeout(() => {
          this.showDialog = false;
        }, 600);
      }
    },
    onSelectICD(item) {
      this.selectedICD = item;
      if (item != {}) {
        setTimeout(() => {
          this.showDialogICD = false;
        }, 600);
      }
    },
    onSelectCTP(item) {
      this.selectedCTP = item;
      if (item != {}) {
        setTimeout(() => {
          this.showDialogCTP = false;
        }, 600);
      }
    },
    onSelectEscuela(item) {
      console.log(item);

      this.selectedEscuela = item;
      this.nombreEscuela = item.Nombre;
      this.nivel = item.Nivel;
      this.municipio = item.Municipio;
      this.clave = item.Clave;
      if (item != {}) {
        setTimeout(() => {
          this.showDialogEscuelas = false;
        }, 500);
      }
    },
    sendDatos() {
      let data = {
        selectedHospital: this.selectedHospital,
        autorizado: this.autorizado,
        dateRegistro: this.dateRegistro,
        horaRegistro: this.horaRegistro,
        descripcionRegistro: this.descripcionRegistro,
        ubicacion: this.ubicacion,
        espacio: this.espacio,
        accidente: this.accidente,
        lesion: this.lesion,
        cuerpo: this.cuerpo,
        nombre: this.nombre,
        apellidoPaterno: this.apellidoPaterno,
        apellidoMaterno: this.apellidoMaterno,
        parentesco: this.parentesco,
        telefono: this.telefono,
        correo: this.correo,
        dateConsulta: this.dateConsulta,
        observaciones: this.observaciones,
        clave: this.clave,
        nombreEscuela: this.nombreEscuela,
        nivel: this.nivel,
        municipio: this.municipio,
        seguro: this.seguro,
        ICD: this.selectedICD,
        CTP: this.selectedCTP,
        primerGasto: this.fechaPrimerGasto,
        primerReclamacion: this.fechaPrimerReclamacion,
      };
      console.log("Boton guardar alta", data);
      this.$emit("dataTabs", data);
    },
    async escuelaSearch() {
      this.isLoadingTabs = true;
      this.errors = false;
      // this.errorClave = false;
      const payload = {
        metodo: "CATALOGOESCUELASISEP",
        data: {
          clave: this.clave,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
          this.selectedEscuela = res[0];
          this.nombreEscuela = res[0].Nombre;
          this.nivel = res[0].Nivel;
          this.municipio = res[0].Municipio;
        } else {
          this.isLoadingTabs = false;
          this.errors = true;
          this.nombreEscuela = "";
          this.nivel = "";
          this.municipio = "";
          this.clave = "";
        }
      } catch (error) {
        //Fin try
        this.errors = true;
        this.nombreEscuela = "";
        this.nivel = "";
        this.municipio = "";
        this.clave = "";
        console.log(error);
        this.isLoadingTabs = false;
      }
      this.isLoadingTabs = false;
    },
    async CTP() {
      this.isLoadingTabs = true;
      const payload = {
        metodo: "CATALOGOCTPISEP",
        data: {
          pCvel_CPT: this.ctpClave || null,
          pDesc_CPT: this.ctpDesc || null,
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.catalogoCTP = res;
          console.log(res);
          if (res.length <= 0) {
            this.isLoadingTabs = false;
            this.showAlert = true;
            this.mensajeAlert = "No se encontro información.";
            setTimeout(() => {
              this.showAlert = false;
            }, 5000);
          }
        } else {
          this.showError = true;
          this.errorMessage = "Hubo un error al consultar CTP";
          this.isLoadingTabs = false;
        }
      } catch (error) {
        //Fin try
        console.log(error);
        this.isLoadingTabs = false;
      }
      this.isLoadingTabs = false;
    },
    async ICD() {
      this.isLoadingTabs = true;
      const payload = {
        metodo: "CATALOGOICDISEP",
        data: {
          pCvel_ICD: this.icdClave || null,
          pDESC_ICD:
            this.icdClave != null || this.icdClave != ""
              ? this.icdDesc
              : "PIEL",
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
          this.catalogoICD = res;
          if (res.length <= 0) {
            this.showAlert = true;
            this.mensajeAlert = "No se encontro información.";
            setTimeout(() => {
              this.showAlert = false;
            }, 5000);
            this.isLoadingTabs = false;
          }
        } else {
          this.showError = true;
          this.errorMessage = "Hubo un error al consultar ICD ";
          this.isLoadingTabs = false;
        }
      } catch (error) {
        //Fin try
        console.log(error);
      }
      this.isLoadingTabs = false;
    },
  },
  computed: {
    errorClave() {
      return this.errors ? "md-invalid" : "";
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.catalogoFiltradoEscuelas.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(
        this.catalogoFiltradoEscuelas.length / this.itemsPerPage
      );
    },
      paginatedDataHospital() {
    const startIndex = (this.currentPageHospital - 1) * this.itemsPerPageHospital;
    const endIndex = startIndex + this.itemsPerPageHospital;
    return this.catalogoFiltradoHospitales.slice(startIndex, endIndex);
  },
  totalPagesHospital() {
    return Math.ceil(this.catalogoFiltradoHospitales.length / this.itemsPerPageHospital);
  }
  },
  mounted() {
    console.log(this.selectedEscuela);
  },
};
</script>
  <style>
.fa-xs {
  font-size: 0.5em !important;
}
.md-switch {
  display: flex;
}
.md-table + .md-table {
  margin-top: 16px;
}
.md-list-item-content {
  color: rgb(56, 56, 56) !important;
}
.md-field.md-has-value .md-required,
.md-field.md-is-focused .md-required {
  transform: translateY(-1.5em); /* Posición ajustada */
  font-size: 12px; /* Tamaño más pequeño para el label al estar activo */
}

.md-field .md-required {
  position: absolute; /* Coloca el label en una posición absoluta */
  top: -0.1em; /* Ajusta la posición hacia arriba */
  left: 0;
  font-size: 12px; /* Tamaño inicial más grande */
  transition: all 0.2s ease-in-out; /* Animación suave */
  pointer-events: none; /* Evita que el label interrumpa el clic en el input */
}

.pagination-nav {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.pagination {
  display: flex;
  list-style: none;
  padding: 0;
}

.pagination li {
  margin: 0 4px;
}

.pagination li a {
  display: block;
  padding: 8px 12px;
  text-decoration: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #007bff;
  cursor: pointer;
}

.pagination li a:hover {
  background-color: #f2f2f2;
}

.pagination li.active a {
  background-color: #007bff;
  color: #fff;
  border-color: #007bff;
}

.pagination li.disabled a {
  color: #ccc;
  cursor: not-allowed;
}
</style>